import React from 'react'
import { Field } from 'redux-form'
import { renderers, validations, titleCase } from '../../../../components'

export const ContactDetailsFields = () => (
  <>
    <Field
      name="first_name"
      label="First Name"
      validate={[validations.required]}
      component={renderers.renderField}
      normalize={titleCase}
      type="text"
    />
    <Field
      name="last_name"
      label="Last Name"
      validate={[validations.required]}
      component={renderers.renderField}
      normalize={titleCase}
      type="text"
    />
    <Field
      name="contact_number"
      label="Contact Number"
      validate={[
        validations.required,
        validations.contactNumber,
        validations.minLength(10),
        validations.maxLength(10),
      ]}
      component={renderers.renderField}
      type="text"
    />
  </>
)
